// Theme preference: follow the device, or force light/dark. A display setting,
// so it lives in plain localStorage (not the encrypted vault) and is applied
// before the lock screen paints. Storage can be unavailable (private mode) —
// every access is guarded and the default is "system".

export type ThemePref = "system" | "light" | "dark";
const KEY = "afm.theme";

export function getTheme(): ThemePref {
  try {
    const v = localStorage.getItem(KEY);
    return v === "light" || v === "dark" ? v : "system";
  } catch {
    return "system";
  }
}

export function applyTheme(pref: ThemePref = getTheme()): void {
  const root = document.documentElement;
  if (pref === "system") root.removeAttribute("data-theme");
  else root.setAttribute("data-theme", pref);
}

export function setTheme(pref: ThemePref): void {
  try {
    if (pref === "system") localStorage.removeItem(KEY);
    else localStorage.setItem(KEY, pref);
  } catch { /* non-fatal: still applied for this session */ }
  applyTheme(pref);
}
